import { render } from "./PitchBrandPanel.vue?vue&type=template&id=5ac0bdc7&scoped=true"
import script from "./PitchBrandPanel.vue?vue&type=script&lang=js"
export * from "./PitchBrandPanel.vue?vue&type=script&lang=js"

import "./PitchBrandPanel.vue?vue&type=style&index=0&id=5ac0bdc7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac0bdc7"]])

export default __exports__